<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 16:05:24
 -->
<!--  -->
<template>
  <el-col :span="8" class="experienceRight">
    <h4>积分排行榜</h4>
    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="personXm" size="medium" clearable
      @keyup.enter.native="searchZanByUser">
    </el-input>

    <el-row class="jfphb_div">
      <el-col :span="8" v-for="(item, index) in dzList" :key="index" class="jfphb">
        <popoverinfo ref="refpopover" :avatar="item.avatr" :baseinfo="baseinfo" @goToda="goToda" />
        <div @click="getPersonalXd(item)" class="jfphb_item">
          <img :src="item.avatr ? item.avatr : '/base/images/layout/user.png'" alt="" class="tx"
            @mouseenter="getpopoverinfo(item,index)">
          <!-- <template v-if="item.avatr==null">
            <img src="/base/images/layout/user.png" class="tx" alt="">
          </template>
          <template v-else>
            <img :src="item.avatr" alt="" class="tx">
          </template> -->

          <span>
            <img src="/base/images/expression/fire1.png" alt="">
            {{item.num}}
          </span>
          <p>
            {{item.xm}}
          </p>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="fy" v-show="isFyShow">
          <el-pagination background layout="prev, pager, next" :page-size=12 @current-change="handleCurrentChange"
            @prev-click="prev" @next-click="next" :total="pageInfo.total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dangan.title" :visible.sync="dangan.dialogVisible" width="60%" top="5vh"
      :before-close="handleClose">
      <danganView :loginName='dangan.loginName' :baseinfo="baseinfo" />
    </el-dialog>
  </el-col>
</template>

<script>
import popoverinfo from '@/portal/base/Experience/components/popoverinfo.vue'
import danganView from '@/portal/base/Experience/components/danganDialog.vue'
export default {
  name: 'ExperienceRight',
  components: {
    popoverinfo, danganView
  },
  data() {
    return {
      baseinfo: {},
      baseallinfo: {},
      dzList: [],
      pageInfo: {
        total: 0
      },
      isFyShow: false,
      personXm: '',
      dangan: {
        loginName: '',
        dialogVisible: false,
        title: '档案'
      }
    }
  },

  mounted() {
    this.getDzQuery({ pageNum: 1, pageSize: 200 })
    // 先获取所有用户基本信息不用每次都去请求
    this.$http.post('/fighter-apis-manage/apis/query/apis-1703123256305').then(res => {
      this.baseallinfo = res.data
    })
  },
  methods: {
    goToda(data) {
      this.dangan.loginName = data.loginName
      this.dangan.dialogVisible = data.type
      this.dangan.title = data.name + '的个人档案'
      // console.log(data)
    },
    getpopoverinfo(item, index) {
      console.log(item.sjh)
      this.baseinfo = this.baseallinfo.filter(e => e.loginName === item.sjh)[0] || ''
      this.$refs.refpopover[index].$refs.refpopover.doShow()
    },
    getDzQuery(pageInfo, name) {
      this.$http.post('/fighter-lightportal-saas/vBbXrblc/queryZanByUser',
        {
          entity: {
            xm: name
          },
          orderItemList: [
            {
              'asc': true,
              'column': ''
            }
          ],
          pageNum: pageInfo.pageNum,
          pageSize: pageInfo.pageSize
        }).then(res => {
          this.dzList = res.data.records
          this.pageInfo.total = res.data.total
          // this.isFyShow = true
          this.$emit('xdTotal', res.data.total)
        }).catch(error => {
          this.$message.error(error.msg)
        })
    },
    searchZanByUser() {
      this.getDzQuery({ pageNum: 1, pageSize: 200 }, this.personXm)
    },
    prev(pageNum) {
      this.getDzQuery({ pageNum: pageNum, pageSize: 200 })
    },
    next(pageNum) {
      this.getDzQuery({ pageNum: pageNum, pageSize: 200 })
    },
    handleCurrentChange(pageNum) {
      this.getDzQuery({ pageNum: pageNum, pageSize: 200 })
    },
    getPersonalXd(val) {
      this.$emit('experienceRightdata', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.experienceRight {
  background-color: white;
  margin-top: 10px;
  padding: 15px;
  box-sizing: border-box;
  border-left: 10px solid #f8f8f8 !important;
  h4 {
    margin-top: 0;
    margin-bottom: 10px;
  }
  :deep(.el-input__inner) {
    border-radius: 50px;
    background-color: #f8f8f8;
    border: 0;
  }

  .tx {
    width: 64px;
    height: 64px;
    border-radius: 100%;
  }
  :deep(.el-pagination) {
    text-align: center;
    margin-top: 30px;
  }
  .jfphb_div {
    height: auto;
    .jfphb {
      position: relative;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 0;
      cursor: pointer;
      height: 100px;
      .jfphb_item {
        span {
          display: inline-block;
          width: 50px;
          border: 1px solid #f1f1f1;
          text-align: center;
          border-radius: 50px;
          position: absolute;
          // left: 1.5rem;
          // top: 3.3125rem;
          color: orange;
          background-color: #ffffff73;
          top: 53px;
        }
      }
      p {
        margin-bottom: 0;
      }
    }
    & :first-child {
      .jfphb_item p {
        color: red;
      }
    }
    & :nth-child(2) {
      .jfphb_item p {
        color: orange;
      }
    }
    & :nth-child(3) {
      .jfphb_item p {
        color: blue;
      }
    }
  }
  .jfphb_item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
